import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import IsEqual from './isEqual';
import { refDataProps, EnergySale } from './types';

/**
 * Reference Data Translator - custom Hook
 * @returns a function which takes a key and a code, and returns a description
 */
export const useRefDataTranslate = () => {
	const [refData, setRefData]: [Array<Array<refDataProps>>, any] = useState([]);
	const [refDataMap, setRefDataMap]: [{ [key: string]: refDataProps[] }, any] = useState({});

	useSelector((state: { saleData: EnergySale; refData: refDataProps[][] }) => {
		if (state.refData && (!refData || !IsEqual(state.refData, refData))) {
			setRefData(state.refData);
		}
	});

	useEffect(() => {
		const newRefDateMap: { [key: string]: refDataProps[] } = {};
		for (let index = 0; index < refData.length; index++) {
			const refDataTypes = refData[index];
			const refDataTypeName = refDataTypes[0].refDataCategory;
			newRefDateMap[refDataTypeName] = refDataTypes;
		}
		setRefDataMap(newRefDateMap);
	}, [refData]);

	return (key: string, code: string): string => {
		if (!refDataMap[key]) return code;
		return refDataMap[key].find((refDataItem) => refDataItem.code === code)?.description ?? code;
	};
};
